import { Users } from 'system/components';
import { SystemSettingsPage } from 'system/pages';

import {
  manufacturersPath,
  partsPath,
  searchPath,
  sitesPath,
  systemSettingsPath,
  usersPath,
} from './routePaths';

export const users = {
  path: usersPath(),
  exact: true,
  isPrivate: true,
  element: <Users />,
};

export const parts = {
  path: partsPath(),
  exact: true,
  isPrivate: true,
  element: <>Parts</>,
};

export const manufacturers = {
  path: manufacturersPath(),
  exact: true,
  isPrivate: true,
  element: <>Manufacturers</>,
};

export const sites = {
  path: sitesPath(),
  exact: true,
  isPrivate: true,
  element: <>Sites</>,
};

export const search = {
  path: searchPath(),
  exact: true,
  isPrivate: true,
  element: <>Search</>,
};

export const systemSettings = {
  path: systemSettingsPath(),
  nestedRoutes: [users, parts, manufacturers, sites, search],
  exact: true,
  isPrivate: true,
  element: <SystemSettingsPage />,
};
